"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Assets = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _ticker = require("../../../ticker");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Small = (0, _styledComponents.default)(_ui.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var Assets = function Assets(_ref2) {
  var ticker = _ref2.ticker;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerIcon, {
    ticker: ticker
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ms-2"
  }, /*#__PURE__*/_react.default.createElement(_ui.P, null, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerName, {
    ticker: ticker
  }))), /*#__PURE__*/_react.default.createElement(Small, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerName, {
    ticker: ticker,
    full: true
  }))));
};
exports.Assets = Assets;